'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retryOnce = undefined;

var _buildError = require('conversations-infrastructure/errors/builders/buildError');

/**
 * Retry calls to an API once.
 *
 * @param {Function} func async function to call.  This function must return a promise
 * @returns {Promise}
 */
var retryOnce = exports.retryOnce = function retryOnce(func) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return func.apply(undefined, args).catch(function () {
      return func.apply(undefined, args);
    }).catch(function (error) {
      throw (0, _buildError.buildError)('Async call failed twice. Reason: ' + error.message, error, { args: args });
    });
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/utils/retryOnce.js
// module id = 794
// module chunks = 2 3